import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {connect} from "react-redux";
import {
  patchCatalogDescription,
  clearPatchCatalogDescription,
} from 'redux/catalog/actions';

import ColorPicker from 'components/dashboard/appearance-content/ColorPicker';

import './CatalogButtonStyleSelector.css';


class CatalogButtonStyleSelector extends Component {
  static propTypes = {
    patchCatalogDescription: PropTypes.func.isRequired,
    clearPatchCatalogDescription: PropTypes.func.isRequired,
    catalogDescription: PropTypes.object,
    label: PropTypes.string.isRequired,
    defaultColor: PropTypes.string.isRequired,
    parameter: PropTypes.string.isRequired,
    pickerId: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }

  static defaultProps = {
    catalogDescription: null,
  }

  state = {
    currentColor: null,
  };

  componentDidMount() {
    const { catalogDescription } = this.props;
    if (catalogDescription) {
      this.setState({
        currentColor: catalogDescription[`${this.props.parameter}`],
      });
    }
  }

  _onColorChange = color => {
    this.setState({ currentColor: color.hex });
    const form = new FormData();
    form.append(this.props.parameter, color.hex);
    this.props.patchCatalogDescription(
      this.props.catalogDescription.id,
      form,
    );
  };

  render() {
    const { label, defaultColor, pickerId, key } = this.props;
    const { currentColor } = this.state;

    return (
      <div className="catalog-button-style-selector__component">
        <div className="picker-wrapper">
          <ColorPicker
            mini
            key={`color-picker-key-${key}`}
            pickerId={pickerId}
            color={currentColor || defaultColor}
            onChangeComplete={this._onColorChange}
            disableAlpha
          />
        </div>

        <div className="info-wrapper">
          <div className="color-hex">{currentColor}</div>
          <div className="label">{label}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    catalogDescription: state.catalogReducer.catalogDescription,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCatalogDescription,
    clearPatchCatalogDescription,
  },
)(CatalogButtonStyleSelector);
